var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollectionOption(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 7,
    viewBox: "0 0 37 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6653_1175)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 3.5,
    r: 3.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 3.5,
    r: 3.5,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6653_1175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 7,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectionOption);
export default __webpack_public_path__ + "static/media/collection-option.a25592d667003468b5c8d850725ae86c.svg";
export { ForwardRef as ReactComponent };